import type { WidgetDefinition } from '../WidgetDefinition';
import { faBell } from '@fortawesome/pro-duotone-svg-icons/faBell';
import type { AlertsWidgetModel } from '@thinkalpha/platform-ws-client/contracts/workspace.js';
import type { AlertsWidgetViewModel } from 'src/store/types';

class AlertsWidgetDefinition implements WidgetDefinition<AlertsWidgetViewModel, AlertsWidgetModel> {
    type = 'alerts' as const;
    nameKey = 'widgets::alerts::name' as const;
    roles = ['widgets::alerts'];
    icon = faBell;
    category = 'widgets::categories::research' as const;
    defaultDimensions = { h: 0.5, w: 0.4, x: 0.3, y: 0.25 };
    maxInstances = 1;

    toViewModel(widget: AlertsWidgetModel): AlertsWidgetViewModel {
        return {
            ...widget,
            activeAlertsTab: widget.activeAlertsTab ?? 'symbols',
            linkedSymbol: null,
        };
    }

    toContractModel(widget: AlertsWidgetViewModel): AlertsWidgetModel {
        return {
            type: widget.type,
            channelId: widget.channelId,
            activeAlertsTab: widget.activeAlertsTab,
        };
    }
}

export const alertsWidgetDefinition = new AlertsWidgetDefinition();
